import { CALL_API } from "admin/middlewares/api";

export const ADD_MANDATOR_REQUEST = "ADD_MANDATOR_REQUEST";
export const ADD_MANDATOR_SUCCESS = "ADD_MANDATOR_SUCCESS";
export const ADD_MANDATOR_ERROR = "ADD_MANDATOR_ERROR";

export function add_mandator_organisation(mandatorSsn, identity) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/users/organisations/AddMandator",
      authenticatedRequest: true,
      method: "POST",
      data: { Identity: identity, MandatorSsn: mandatorSsn },
      types: [ADD_MANDATOR_REQUEST, ADD_MANDATOR_SUCCESS, ADD_MANDATOR_ERROR],
    },
  };
}

export const REMOVE_MANDATOR_REQUEST = "REMOVE_MANDATOR_REQUEST";
export const REMOVE_MANDATOR_SUCCESS = "REMOVE_MANDATOR_SUCCESS";
export const REMOVE_MANDATOR_ERROR = "REMOVE_MANDATOR_ERROR";

export function remove_mandator_organisation(mandatorIdentity, identity) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/users/organisations/RemoveMandator",
      authenticatedRequest: true,
      method: "POST",
      data: { Identity: identity, MandatorIdentity: mandatorIdentity },
      types: [
        REMOVE_MANDATOR_REQUEST,
        REMOVE_MANDATOR_SUCCESS,
        REMOVE_MANDATOR_ERROR,
      ],
    },
  };
}
